const baseURL = 'https://marialtienda.com';

export default baseURL;
